{
  "anySpecialist": {
    "text": "मुझे उपलब्ध अपॉइंटमेंट समयों की सबसे विस्तृत सूची दिखाएं।",
    "title": "मुझे कोई फर्क नहीं पड़ता"
  },
  "nextLabel": "$t(common:next): <b>समय चुनें</b>",
  "profile": "विशेषज्ञ प्रोफ़ाइल",
  "specialists": {
    "00000000-0000-da7a-0003-000000000004": {
      "name": "Dr. Lopez"
    }
  },
  "textMultiple": "<p>ये सभी विशेषज्ञ बेहतरीन विकल्प हैं। किसी एक को चुनें, या “मुझे कोई फर्क नहीं पड़ता” विकल्प के साथ आगे बढ़ें।</p>",
  "textSingle": "<p>आपके जीपी – {{referral.gp}} – ने आपको यहां रेफर किया है:</p>",
  "titleMultiple": "अपने विशेषज्ञ का चयन करें",
  "titleSingle": "आपके विशेषज्ञ",
  "viewProfile": "पूरा प्रोफ़ाइल देखें"
}
